<template>
  <div class="info-box">
    <div
      class="p-4 flex flex-col overflow-y-auto gap-y-3 border-t flex-1"
      id="printDom"
    >
      <ul class="font-bold text-center text-gray-900 text-xl mt-3">
        {{
          state.meeting?.bill_title
        }}会议项目核算单
      </ul>
      <c_cell title="会议名称" class="mt-3">
        <template #default>
          <strong>{{ state.meeting?.name }}</strong>
        </template>
      </c_cell>
      <ul class="grid grid-cols-2">
        <c_cell title="会议编号" :value="state.meeting?.number" />
        <c_cell
          title="会议时间"
          :value="state.meeting?.start_date + ' ~ ' + state.meeting?.end_date"
        />
      </ul>
      <ul class="flex gap-x-5">
        <c_cell title="会议负责人" :value="state.meeting?.belonger_name" />
        <!-- <c_cell title="设计师" :value="state.meeting?.start_time" />
        <c_cell title="车队调度员" :value="state.meeting?.start_time" />
        <c_cell title="物料采购员" :value="state.meeting?.start_time" /> -->
      </ul>
      <div class="border rounded-lg p-2.5">
        <strong class="text-xs">一、会议核算审批摘要信息</strong>
        <div class="flex flex-col gap-y-1 mt-2">
          <ul class="flex gap-x-3 items-center">
            <c_cell title="总产值(甲方收款)">
              <template #default>
                <c_money
                  :key="state.meetingAccounting?.receivable_amount"
                  :value="state.meetingAccounting?.receivable_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="已收款">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.collected_amount"
                  :key="state.meetingAccounting?.collected_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="欠款">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.uncollected_amount"
                  :key="state.meetingAccounting?.uncollected_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
          </ul>
          <ul class="flex gap-x-3 items-center">
            <c_cell title="报账总金额(乙方)">
              <template #default>
                <c_money
                  :key="state.meetingAccounting?.bill_amount"
                  :value="state.meetingAccounting?.bill_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="报账金额">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.bill_item_amount"
                  :key="state.meetingAccounting?.bill_item_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="服务费">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.service_fee_amount"
                  :key="state.meetingAccounting?.service_fee_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="税费">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.tax_fee_amount"
                  :key="state.meetingAccounting?.tax_fee_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span
              class="text-gray-400"
              style="margin-left: -10px; font-size: 14px"
            >
              税率({{
                $formatDecimal(state.meetingAccounting?.tax_fee_rate)
              }}%)
            </span>
          </ul>
          <ul class="flex gap-x-3 items-center">
            <c_cell title="采购金额合计">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.purchase_amount"
                  :key="state.meetingAccounting?.purchase_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <!-- <c_cell title="物料采购金额合计">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.material_purchase_amount"
                  :key="state.meetingAccounting?.material_purchase_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <c_cell title="费用采购金额合计">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.expense_purchase_amount"
                  :key="state.meetingAccounting?.expense_purchase_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell> -->
          </ul>
          <ul class="flex gap-x-3 items-center">
            <c_cell title="税务成本">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.cost_tax_fee_amount"
                  :key="state.meetingAccounting?.cost_tax_fee_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-sm">
              ((应税报账金额合计 + 服务费)* 成本税率({{
                $formatDecimal(state.meetingAccounting?.cost_tax_fee_rate)
              }}%))
            </span>
          </ul>
          <ul class="flex gap-x-3 items-center">
            <c_cell title="毛利">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.gross_profit"
                  :key="state.meetingAccounting?.gross_profit"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-sm">
              (报账总金额(乙方)- 采购金额合计 - 税务成本)
            </span>
            <c_cell title="毛利率">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.gross_profit_rate"
                  :key="state.meetingAccounting?.gross_profit_rate"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
          </ul>
          <ul class="flex gap-x-3 items-center">
            <c_cell title="设计师应发提成">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.designer_commission"
                  :key="state.meetingAccounting?.designer_commission"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-sm">
              ((参与提成报账金额合计 - 参与提成采购金额合计)* 设计师提成系数({{
                $formatDecimal(
                  state.meetingAccounting?.designer_commission_rate,
                )
              }}%))
            </span>
          </ul>
          <ul class="flex gap-x-3 items-center">
            <c_cell title="项目经理应发提成">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.manager_commission"
                  :key="state.meetingAccounting?.manager_commission"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-sm">
              ((毛利 - 设计师应发提成)* 项目经理提成系数({{
                $formatDecimal(
                  state.meetingAccounting?.manager_commission_rate,
                )
              }}%))
            </span>
          </ul>
          <ul class="flex gap-x-3 items-center">
            <c_cell title="会议结转收入">
              <template #default>
                <c_money
                  :value="state.meetingAccounting?.forward_amount"
                  :key="state.meetingAccounting?.forward_amount"
                  bold
                  :prefix="false"
                  color="#080"
                />
              </template>
            </c_cell>
            <span class="text-gray-400 text-sm">(已收款 - 报账总金额)</span>
          </ul>
        </div>
      </div>
      <strong class="text-xs">二、会议成本及乙方报账金额明细如下：</strong>
      <div class="hesuanprint-tab text-xs">
        <table cellpadding="5">
          <thead>
            <tr>
              <th class="!w-7">序号</th>
              <th>分类</th>
              <th>供应商</th>
              <th>采购摘要</th>
              <th>采购单价/数量/天数/总金额</th>
              <th>乙方报账单价/数量/天数/总金额</th>
              <th>差额</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in state.meetingBillItemList"
              :key="item.id"
            >
              <td>{{ index + 1 }}</td>
              <td class="whitespace-nowrap">
                {{ item.d_cost_type_name }}
              </td>
              <td>{{ item.supplier.name || "-" }}</td>
              <td>
                {{
                  !item.specification || item.specification == "无"
                    ? "-"
                    : item.specification
                }}
              </td>
              <td>
                {{ $priceFormat(item.price) }}/{{ item.count }}/{{
                  item.day_count || "-"
                }}/{{ $priceFormat(item.amount) }}
              </td>
              <td>
                {{ $priceFormat(item.bill_price) }}/{{ item.bill_count }}/{{
                  item.bill_day_count || "-"
                }}/{{ $priceFormat(item.bill_amount) }}
              </td>
              <td class="font-bold">
                {{ $priceFormat(item.diff) }}
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 
        <el-table
          :data="state.meetingBillItemList"
          v-loading="!Array.isArray(state.meetingBillItemList)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :showOverflowTooltip="false"
        >
          <el-table-column
            label="分类"
            prop="d_cost_type_name"
            :formatter="$tab_TextFormat"
            width="80px"
          >
            <template #default="{ row }">
              <text>{{
                row.d_cost_type_pname + " - " + row.d_cost_type_name
              }}</text>
            </template>
          </el-table-column>
          <el-table-column
            label="供应商"
            prop="supplier.name"
            :formatter="$tab_TextFormat"
            align="center"
          />
          <el-table-column label="采购摘要" align="center">
            <template #default="{ row }">
              <text>{{ row.specification }}</text>
            </template>
          </el-table-column>
          <el-table-column label="采购单价/数量/天数/总金额" align="right">
            <template #default="{ row }">
              <div class="flex items-center justify-end">
                <text style="color: #080">{{ $priceFormat(row.price) }}</text>
                <text class="text-gray-400">{{ "/" + row.count }}</text>
                <text class="text-gray-400">{{
                  "/" + (row.day_count || "-") + "/"
                }}</text>
                <c_money
                  :value="row.amount"
                  :key="row.amount"
                  :prefix="false"
                  color="#080"
                  bold
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="乙方报账单价/数量/天数/总金额" align="right">
            <template #default="{ row }">
              <div class="flex items-center justify-end">
                <text style="color: #080">{{
                  $priceFormat(row.bill_price)
                }}</text>
                <text class="text-gray-400">{{ "/" + row.bill_count }}</text>
                <text class="text-gray-400">{{
                  "/" + row.bill_day_count + "/"
                }}</text>
                <c_money
                  :value="row.bill_amount"
                  :key="row.bill_amount"
                  :prefix="false"
                  color="#080"
                  bold
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="差额" align="right" :width="120">
            <template #default="{ row }">
              <c_money
                :value="row.diff"
                :key="row.diff"
                :prefix="false"
                class="!w-full justify-end"
                bold
              />
            </template>
          </el-table-column>
        </el-table> -->
      </div>
      <strong class="text-xs">三、会议收款计划如下：</strong>
      <div class="hesuanprint-tab2 text-xs">
        <table cellpadding="15">
          <thead>
            <tr>
              <th class="!w-7">序号</th>
              <th>收款对象(甲方)</th>
              <th>计划收款金额</th>
              <th>已收</th>
              <th>欠款</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in state.meetingCollectedPlanList"
              :key="item.id"
            >
              <td>{{ index + 1 }}</td>
              <td>
                {{ item.customer?.name + " - " + item.customer?.number }}
              </td>
              <td>{{ $priceFormat(item.amount) }}</td>
              <td>{{ $priceFormat(item.collected_amount) }}</td>
              <td>{{ $priceFormat(item.uncollected_amount) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="submit-box px-2.5">
      <el-button
        v-show="false"
        plain
        :icon="Printer"
        v-print="printObj"
        ref="printBtn"
      >
        打印核算单
      </el-button>
      <el-button plain :icon="Printer" @click="onPrint">打印核算单</el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { meeting_accountingDetail } from "@/http/meeting";
import { toDecimal } from "@/utils/funcs";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const printObj = {
      id: "printDom",
      // 注入打印样式：分页 + 底部页码
      extraHead: `
      <style>
        @media print {
          @page {
            size: A4 landscape;   /* A4横向 */
            position: relative;
            /* 底部预留页码位置 */
            @bottom-center {
              content: "第" counter(page) "页";
              font-size:12px;
              margin-top:-5mm;
            }
          }
        }
      </style>
    `,
    };
    const printBtn = ref(null);
    const formDom = ref(null);
    const state = reactive({
      model: {
        id: props.id,
      },
      meeting: {},
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      meeting_accountingDetail(props.id).then((res) => {
        if (res.status == 200) {
          const {
            meeting,
            meetingAccounting,
            meetingPurchaseItemList,
            meetingCollectedPlanList,
          } = res.data?.data;
          state.meeting = meeting;
          state.meetingAccounting = meetingAccounting;
          state.meetingBillItemList = meetingPurchaseItemList.map((m) => {
            return {
              ...m,
              diff: toDecimal(m.bill_amount).minus(toDecimal(m.amount)),
            };
          });
          state.meetingCollectedPlanList = meetingCollectedPlanList;
        }
      });
    };

    //打印
    const onPrint = () => {
      printBtn.value.$el.click();
    };

    return {
      state,
      props,
      formDom,
      printObj,
      onPrint,
      printBtn,
    };
  },
};
</script>

<style lang="scss" scoped>
.hesuanprint-tab {
  & > table {
    text-align: center;
    width: 100%;

    & > thead {
      & > tr {
        & > th {
          white-space: nowrap;
        }
      }
    }

    & > tbody {
      & > tr {
        border-top: 1px solid #f4f4f4;
      }
    }
  }
}

.hesuanprint-tab2 {
  & > table {
    width: 100%;

    & > thead {
      & > tr {
        & > th:nth-child(2) {
          text-align: left;
        }
        & > th:not(:nth-child(2)) {
          text-align: center;
          white-space: nowrap;
        }
      }
    }

    & > tbody {
      & > tr {
        border-top: 1px solid #f4f4f4;

        & > td:nth-child(2) {
          text-align: left;
        }
        & > td:not(:nth-child(2)) {
          text-align: center;
        }
      }
    }
  }
}
</style>
<style type="scss"></style>
